<script lang="ts">
import SidebarMenuItem from "@/components/SidebarMenuItem.vue"
import { mapGetters } from "vuex"
import ThemedLoading from "@/components/ThemedLoading.vue"

export default {
    name: "SidebarMenu",
    components: {
        SidebarMenuItem,
        ThemedLoading,
    },
    props: {
        menu: {
            type: Array as () => any[],
            required: true,
        },
        openItemId: {
            type: [String],
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menuKey: 0,
        }
    },
    watch: {
        menu: {
            handler() {
                this.menuKey++
            },
            deep: true,
        },
    },
    computed: {
        ...mapGetters("auth", {
            user: "user",
        }),
    },
    methods: {
        shouldCollapseInitially(index: number) {
            return index !== 0
        },
    },
}
</script>

<template>
    <div
        id="main-sidebar-content-wrapper"
        ref="sidebarContentWrapper"
        :key="menuKey"
        style="position: relative"
    >
        <ThemedLoading :active="isLoading" :is-full-page="false" :opacity="0.9" />
        <SidebarMenuItem
            v-for="(item, index) in menu"
            :key="`${item.id}-${item.title}`"
            :item="item"
            :collapse="
                shouldCollapseInitially(index) || (openItemId !== null && openItemId !== item.id)
            "
            @item-opened="$emit('item-click', $event)"
        />
    </div>
</template>
